import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FiFolder,
  FiTag,
  FiLayers,
  FiDatabase,
} from "react-icons/fi";

const TABS = [
  {
    step: "1",
    label: "Projects Master",
    route: "/ProjectsMaster",
    icon: <FiFolder className="text-lg" />,
  },
  {
    step: "2",
    label: "Type Master",
    route: "/TypeMaster",
    icon: <FiTag className="text-lg" />,
  },
  {
    step: "3",
    label: "Module Master",
    route: "/ModuleMaster",
    icon: <FiLayers className="text-lg" />,
  },
  {
    step: "4",
    label: "Table Master",
    route: "/TableMaster",
    altRoutes: ["/CliendAdd"],
    icon: <FiDatabase className="text-lg" />,
  },
];

const TableNavTabs = ({ title }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isTabActive = (tab) => {
    if (location.pathname === tab.route) return true;
    if (tab.altRoutes && tab.altRoutes.includes(location.pathname)) return true;
    return false;
  };

  return (
    <div className="title my-4">
      {/* Project Standard Header Title */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {title || "Table Management"}
          </h3>
        </div>

        {/* Tab switchers matching project theme */}
        <div className="flex flex-wrap items-center gap-2">
          {TABS.map((tab) => {
            const active = isTabActive(tab);
            return (
              <button
                key={tab.route}
                onClick={() => navigate(tab.route)}
                className={`flex items-center gap-2 px-4 py-2 rounded text-sm transition-all duration-150 ${
                  active
                    ? "All_button text-white font-semibold shadow"
                    : "bg-white text-[#133a69] font-medium border-2 border-black/20 hover:border-black/60"
                }`}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TableNavTabs;
